module.exports = __webpack_public_path__ + "static/media/history_1.da635390.jpg";